<template>
  <div class="flex w-full items-center justify-center my-3">
    <div v-if="inlineBorder" class="w-full border-b border-b-[#eaeaea]"></div>
    <div
        class="cursor-pointer flex justify-evenly border border-[#eaeaea] rounded-full items-center bg-white h-10 min-w-36"
        @click="loadMore">
      <van-loading v-if="loading" size="20"/>
      <template v-else>
        <div class="flex justify-center">{{ $t('common.load_more') }}</div>
        <van-icon :size="18" class="text-grey-muted" name="arrow-down"/>
      </template>
    </div>
    <div v-if="inlineBorder" class="w-full border-b border-b-[#eaeaea]"></div>
  </div>
</template>

<script setup>
const props = defineProps({
  modelValue: {
    type: Number,
    default: 1
  },
  loading: {
    type: Boolean,
    default: false
  },
  inlineBorder: {
    type: Boolean,
    default: true
  }
})

const emit = defineEmits(['update:modelValue', 'change'])

const loadMore = () => {
  emit('update:modelValue', props.modelValue + 1)
  emit('change')
}
</script>

<style scoped>

</style>